<template>
  <div class="ontag">
    <div class="ontag__content">
      <div>
        <span class="h1">To do - Invoice addresses</span>
        <span
          v-if="isLoading"
          class="element--is-loading"></span>
      </div>
      <template v-if="invoiceAddresses && !isLoading">
        <template v-if="(id || handleTask) && invoiceAddress">
          <template v-if="invoiceAddress.type === 'New'">
            <a @click="showNone"> &lt; Tillbaka </a>
            <table>
              <h4>{{ invoiceAddress.type }} invoice address</h4>
              <p>Status: {{ invoiceAddress.status }}</p>
              <p v-if="invoiceAddress.lastChanged">
                Last update: {{ invoiceAddress.lastChanged }} by
                {{ invoiceAddress.lastChangedBy }}
              </p>
              <p>Comment (Mandatory if Paused)</p>
              <textarea v-model="invoiceAddress.comment"></textarea>
              <h3>CRM data</h3>
              <h4>Customer legal entity name:</h4>
              <p>{{ invoiceAddress.companyName }}</p>
              <h4>Accountname:</h4>
              <p>{{ invoiceAddress.companyName }}</p>
              <h4>Parent account:</h4>
              <p>{{ invoiceAddress.parentAccount }}</p>
              <h4>Account key Customer Code:</h4>
              <p>{{ invoiceAddress.accountKeyCustomerCode }}</p>
              <h4>Tax organizationnumber:</h4>
              <p>{{ invoiceAddress.taxOrganizationNumber }}</p>
              <h4>DUNS Number:</h4>
              <p>{{ invoiceAddress.dunsNumber }}</p>
              <h3>Bill to/Ship to:</h3>
              <h4>Country:</h4>
              <p>{{ invoiceAddress.country }}</p>
              <h4>Address Line 1:</h4>
              <p>{{ invoiceAddress.postalAddress }}</p>
              <h4>Address Line 2-3:</h4>
              <p>{{ invoiceAddress.addressLine23 }}</p>
              <h4>Country Code:</h4>
              <p>{{ invoiceAddress.countryCode }}</p>
              <h4>Postal Code:</h4>
              <p>{{ invoiceAddress.postalCode }}</p>
              <h4>City:</h4>
              <p>{{ invoiceAddress.city }}</p>
              <h4>Global Location Number:</h4>
              <p>{{ invoiceAddress.globalLocationNumber }}</p>
              <hr />
              <h4>Responsible team:</h4>
              <p>{{ invoiceAddress.responsibleTeam }}</p>
              <hr />
              <h4>Invoice Language:</h4>
              <p>{{ invoiceAddress.invoiceLanguage }}</p>
              <template v-if="invoiceAddress.email">
                <h4>Invoice language:</h4>
                <p>To Email(s)</p>
              </template>
              <template v-else-if="invoiceAddresses && !isLoading">
                <h4>Invoice language:</h4>
                <p>To invoice Hotel</p>
                <h4>e-Invoice:</h4>
                <p>No</p>
              </template>
              <h4>Invoice with attachments:</h4>
              <p>Yes</p>
              <h4>Customer Invoice email address(es)/Primary email address:</h4>
              <p>{{ invoiceAddress.email }}</p>
              <h4>VAT:</h4>
              <p>{{ invoiceAddress.vat }}</p>
              <h4>Payment terms:</h4>
              <p>{{ invoiceAddress.paymentTerms }}</p>
              <h4>Add Invoicing Person(s):</h4>
              <p>{{ invoiceAddress.reference }}</p>
              <hr />
              <p>Please enter project number in TERP</p>
              <input v-model="invoiceAddress.terpId" /><br />
              <br />
              <p v-if="invoiceAddress.doneDate && invoiceAddress.doneBy">
                Task done:
                {{
                  invoiceAddress.doneDate == null ? '' : invoiceAddress.doneDate
                }}
                {{ invoiceAddress.doneBy }}
              </p>
              <p>
                Task paused:
                {{
                  invoiceAddress.pausedDate == null
                    ? ''
                    : invoiceAddress.pausedDate
                }}
                {{ invoiceAddress.pausedBy }}
              </p>
              <p v-if="invoiceAddress.waitedDate && invoiceAddress.waitedBy">
                Task waited:
                {{
                  invoiceAddress.waitedDate == null
                    ? ''
                    : invoiceAddress.waitedDate
                }}
                {{ invoiceAddress.waitedBy }}
              </p>
              <br />
            </table>
          </template>
          <template
            v-if="invoiceAddress.type === 'Changed' && (id || handleTask)">
            <a @click="showNone"> &lt; Tillbaka </a>
            <section>
              <h4>
                {{ invoiceAddress.index }}
                {{ invoiceAddress.type }} invoice address
              </h4>
              <p>Id: {{ invoiceAddress.id }}</p>
              <p>Status: {{ invoiceAddress.status }}</p>
              <p
                v-if="
                  invoiceAddress.lastChanged && invoiceAddress.lastChangedBy
                ">
                Last updated: {{ invoiceAddress.lastChanged }} by
                {{ invoiceAddress.lastChangedBy }}
              </p>
              <p>Project number in TERP: {{ invoiceAddress.terpId }}</p>
              <p>Comment (Mandatory if Paused)</p>
              <textarea v-model="invoiceAddress.comment"></textarea>
              <h4>Tax organizationnumber:</h4>
              <p>{{ invoiceAddress.taxOrganizationNumber }}</p>
              <h4>Customer legal entity name:</h4>
              <p>{{ invoiceAddress.companyName }}</p>
              <h4>Address Line 1:</h4>
              <p>{{ invoiceAddress.postalAddress }}</p>
              <h4>Postal Code:</h4>
              <p>{{ invoiceAddress.postalCode }}</p>
              <h4>City:</h4>
              <p>{{ invoiceAddress.city }}</p>
              <h4>E-mail address for invoice</h4>
              <p>{{ invoiceAddress.email }}</p>
              <h4>Referens</h4>
              <p>{{ invoiceAddress.reference }}</p>
              <br />
            </section>
          </template>
          <template v-if="invoiceAddress.externalId">
            <div class="input-group--inline">
              <base-button
                class="button--background-gray-dark"
                @click="showNone()"
                text="Cancel">
              </base-button>
              <base-button
                class="button--background-red"
                @click="reset()"
                :disabled="setDisabledResetButton()"
                :text="
                  'Reset' +
                  (index < invoiceAddresses.length - 1 && handleTask
                    ? ' and next'
                    : '')
                ">
              </base-button>
              <base-button
                class="button--background-red"
                :disabled="setDisabledPauseButton()"
                @click="pause()"
                :text="
                  'Pause' +
                  (index < invoiceAddresses.length - 1 && handleTask
                    ? ' and next'
                    : '')
                ">
              </base-button>
              <base-button
                class="button--background-blue"
                :disabled="setDisabledDoneButton()"
                @click="done()"
                :text="
                  'Done' +
                  (index < invoiceAddresses.length - 1 && handleTask
                    ? ' and next'
                    : '')
                ">
              </base-button>
              <base-button
                class="button--background-blue"
                :disabled="setDisabledWaitButton()"
                @click="waitingForCrm()"
                :text="
                  'Waiting for CRM process' +
                  (index < invoiceAddresses.length - 1 && handleTask
                    ? ' and next'
                    : '')
                ">
              </base-button>
            </div>
          </template>
        </template>
        <template v-else>
          <section class="todos_top-container">
            <input
              type="text"
              placeholder="Search"
              v-model="searchQuery" />
            <base-button
              :disabled="isLoading"
              text="Handle tasks"
              @click="handleTasks(0)">
            </base-button>
            No of events in list: {{ filteredInvoiceAddresses.length }}
          </section>
          <table>
            <thead>
              <th>Id</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Status"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'status')"
                  :options="filterValues('status')">
                </multi-select>
              </th>
              <th>Club name</th>
              <th>Company name</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Type"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'type')"
                  :options="filterValues('type')">
                </multi-select>
              </th>
              <th>Project number</th>
              <th>Date</th>
              <th>
                <multi-select
                  :use-icon="true"
                  icon-name="filter-icon"
                  label="Last updated by"
                  :id="'list-table__filter'"
                  @optionSelected="e => filterResults(e, 'lastChangedBy')"
                  :options="filterValues('lastChangedBy')">
                </multi-select>
              </th>
              <th></th>
            </thead>
            <tr
              v-for="(invoice, i) in filteredInvoiceAddresses"
              v-bind:key="i">
              <td>{{ invoice.id }}</td>
              <td>{{ invoice.status }}</td>
              <td>{{ invoice.clubName }}</td>
              <td>{{ invoice.companyName }}</td>
              <td>{{ invoice.type }}</td>
              <td>{{ invoice.terpId }}</td>
              <td>{{ invoice.lastChanged }}</td>
              <td>{{ invoice.lastChangedBy }}</td>
              <td @click="handleInvoiceAddressTodo(invoice.externalId, index)">
                <use-svg
                  svg="arrow-right"
                  class="svg--90-negative" />
              </td>
            </tr>
          </table>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/components/form-elements/base-button';
import MultiSelect from '@/components/form-elements/multi-select';
import UseSvg from '@/components/use-svg';
import { mapGetters, mapActions } from 'vuex';

const STATUS = {
  PAUSED: 'Paused',
  WAITING: 'Waiting for process in CRM',
  DONE: 'Done',
  CANCELLED: 'Cancelled',
  NEW: 'New',
  TODO: 'To do',
};

export default {
  name: 'InvoiceAddress',
  components: {
    BaseButton,
    MultiSelect,
    UseSvg,
  },
  props: {
    id: String,
  },
  data() {
    return {
      isLoading: true,
      filter: {
        status: [STATUS.PAUSED, STATUS.WAITING, STATUS.TODO],
        type: [],
        lastChangedBy: [],
      },
      sortBy: 'changedDate',
      handleTask: false,
      index: 0,
      searchQuery: '',
    };
  },
  computed: {
    ...mapGetters('todo', ['invoiceAddresses', 'invoiceAddress']),
    filteredInvoiceAddresses() {
      return this.invoiceAddresses
        .filter(
          a =>
            this.filter.status.includes(a.status) ||
            this.filter.type.includes(a.type) ||
            this.filter.lastChangedBy.includes(a.lastChangedBy)
        )
        .filter(a =>
          Object.values(a).some(value =>
            value
              .toString()
              .toLowerCase()
              .includes(this.searchQuery.toLowerCase())
          )
        )
        .sort((a, b) => (a[this.sortBy] > b[this.sortBy] ? 1 : -1));
    },
  },
  async mounted() {
    this.isLoading = true;
    try {
      if (!this.id && !this.invoiceAddresses.length) {
        await this.getInvoiceAddresses();
      }
    } catch (error) {
      console.error('Failed to load invoice addresses:', error);
    } finally {
      this.isLoading = false;
    }
  },
  watch: {
    id: {
      immediate: true,
      async handler(newId) {
        this.isLoading = true;
        try {
          if (newId) {
            await this.getInvoiceAddress({ id: newId });
          } else {
            this.showNone();
          }
        } finally {
          this.isLoading = false;
        }
      },
    },
  },
  methods: {
    ...mapActions('todo', [
      'getInvoiceAddresses',
      'getInvoiceAddress',
      'patchInvoiceAddress',
    ]),
    async showInvoice(id, index) {
      try {
        await this.getInvoiceAddress({ id });
        this.index = index;
      } catch (error) {
        console.error('Failed to show invoice:', error);
      }
    },
    handleInvoiceAddressTodo(id, index) {
      this.index = index;
      this.$router.push({ name: 'todo-invoiceaddress', params: { id: id } });
    },
    showNone() {
      this.isLoading = true;
      this.invoiceAddress.externalId = '';
      this.handleTask = false;
      this.index = 0;
      if (this.id) {
        this.$router.push({ name: 'todo-invoiceaddress' });
      }
      this.isLoading = false;
    },
    waitingForCrm() {
      this.updateInvoiceStatus(STATUS.WAITING);
    },
    pause() {
      this.updateInvoiceStatus(STATUS.PAUSED);
    },
    reset() {
      this.updateInvoiceStatus(STATUS.TODO);
    },
    done() {
      this.updateInvoiceStatus(STATUS.DONE);
    },
    isStatus(status) {
      return this.invoiceAddress.status.toLowerCase() === status.toLowerCase();
    },
    setDisabledDoneButton() {
      return (
        this.isStatus('done') ||
        this.isStatus('cancelled') ||
        (this.invoiceAddress.type === 'New' && !this.invoiceAddress.terpId)
      );
    },
    setDisabledWaitButton() {
      return (
        this.isStatus('waiting for process in CRM') ||
        this.isStatus('cancelled')
      );
    },
    filterValues(prop) {
      return [...new Set(this.invoiceAddresses.map(a => a[prop]))].map(a => {
        return {
          displayName: a,
          value: a,
          checked: this.filter[prop].includes(a),
        };
      });
    },
    setDisabledPauseButton() {
      return (
        this.isStatus(STATUS.CANCELLED) ||
        this.isStatus(STATUS.PAUSED) ||
        !this.invoiceAddress.comment
      );
    },
    setDisabledResetButton() {
      return this.isStatus(STATUS.DONE) === false;
    },
    async updateInvoiceStatus(status) {
      this.isLoading = true;
      await this.patchInvoiceAddress({
        id: this.invoiceAddress.externalId,
        status,
        terpId: this.invoiceAddress.terpId,
        comment: this.invoiceAddress.comment,
      }).then(() => {
        if (
          this.handleTask &&
          this.index < this.filteredInvoiceAddresses.length - 1
        ) {
          this.index += 1;
          this.handleTasks(this.index);
        } else {
          this.showNone();
        }
      });
      this.isLoading = false;
    },
    filterResults(e, prop) {
      this.filter[prop] = e.options
        .filter(option => option.checked)
        .map(o => o.value);
    },
    handleTasks(index) {
      this.showInvoice(this.invoiceAddresses[index].externalId, index);
      if (index < this.invoiceAddresses.length - 1) {
        this.handleTask = true;
      } else {
        this.handleTask = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.todos_top-container {
  display: flex;
  flex-direction: column;
  width: fit-content;
  gap: 12px;
  margin-bottom: 12px;
}

table {
  border-collapse: collapse;
  th {
    padding: 0 0.625rem;
    text-align: left;
    background-color: color(blue-light);
  }
  tr {
    &.pointer {
      cursor: auto;
    }
    &:nth-child(even) {
      background-color: color(gray-lighter);
    }
    &.checked {
      background-color: color(blue-light);
    }
  }
  td {
    padding: 0.625rem;
    &:last-child {
      padding-right: 0;
      cursor: pointer;
    }
  }
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
  margin-bottom: 20px;
}
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.ontag {
  flex-grow: 1;
  width: 100%;
  @include media('small') {
    width: calc((100% / 2) - (1rem * 1));
  }
  @include media('large') {
    width: calc((100% / 3) - (1rem * 2));
  }
}
.ontag__content {
  background-color: color(white);
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  &.dashboard {
    background-color: transparent;
    border-radius: 0;
  }
}
.input-group--inline {
  button {
    margin: 0.5rem;
  }
}
</style>
